import { ApolloError } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const getApolloErrorMessage = (err: ApolloError | undefined) => {
  // @ts-expect-error типизация неправильная
  return err?.cause?.extensions?.originalError?.error;
};
